/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {computeDisclosureSyncValue} from '../api'

export const useMutationComputeDisclosureSyncValue = createReactQueryMutationHook('computeDisclosureSyncValue', computeDisclosureSyncValue)
